import type { ParamsGetInputsProductsAll } from "@CommonApi/inputs/products/all";
import { normalizeMultiValue } from "src/merchflows/shared/multiValue";

export const normalizeInputsProductsAllQueryParams = (
  queryParams?: ParamsGetInputsProductsAll,
): ParamsGetInputsProductsAll | undefined => {
  if (!queryParams) {
    return undefined;
  }

  return {
    ...queryParams,
    category: normalizeMultiValue(queryParams.category),
    subcategory: normalizeMultiValue(queryParams.subcategory),
  };
};
